"use client";

import axiosInstance from "axios";
import {toast} from "react-toastify";

const AuthAxios = axiosInstance.create({
    baseURL: process.env.REACT_APP_API_URL
})

AuthAxios.interceptors.request.use((req) => {
    const controller = new AbortController();
    const getUserData = JSON.parse(localStorage.getItem("userData"));
    const authToken = getUserData?.data?.data?.tokens?.access?.token;
    if (authToken) {
        req.headers['Authorization'] = 'Bearer ' + authToken
    } else {
        controller.abort();
    }
    return { ...req, signal: controller.signal }
})

AuthAxios.interceptors.response.use(res => {
    return res
}, (err) => {
    if(err?.response?.status === 401){
        // localStorage.removeItem("user_id");
        // localStorage.removeItem("user_email");
        // localStorage.removeItem("token");
        // window.location.replace("/auth/login")
    } else {
        toast.error(err?.response?.data?.message || "Error occurred, please try again.");
    }
})



export default AuthAxios
